(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-occasion-product-card"] && !Shopify.designMode) return;
  try {
    class CountdownTimer {
    constructor() {
      this.timers = new Map();
      this.init();
    }

    init() {
      this.initializeTimers();
    }

    initializeTimers() {
      const containers = document.querySelectorAll('.category-status-container');

      containers.forEach((container, index) => {
        const timer = container.querySelector('.timer-layout-minutes');

        if (timer) {
          this.startCountdown(container, `timer-${index}`, timer);
        }
      });
    }

    startCountdown(container, timerId, timer) {
      const timerPartOneSpan = timer ?. querySelector('.timer-part-01 span');

      if (!this.isValidNumber(timerPartOneSpan.textContent)) {
        return;
      }

      let currentValue = this.parseNumber(timerPartOneSpan.textContent);

      const intervalId = setInterval(() => {
        currentValue--;

        timerPartOneSpan.textContent = this.formatDisplayValue(currentValue);

        if (currentValue <= 0) {
          this.handleTimerEnd(intervalId, timerId, container, timer);
        }
      }, 58000);

      this.timers.set(timerId, {intervalId, container, timerPartOneSpan});
    }

    handleTimerEnd(intervalId, timerId, container, timer) {
      const timerPartTwo = timer ?. querySelector('.timer-part-02');
      const timerPartOneSpan = timer ?. querySelector('.timer-part-01 span');

      clearInterval(intervalId);
      this.timers.delete(timerId);

      timerPartOneSpan.textContent = '00';
      timerPartOneSpan.classList.add('timer-ended');

      timerPartTwo.innerHTML = '<div class="counter-number"><span>00</span></div>';

      setTimeout(() => {
        container.innerHTML = '<div class="status-badge ended">Ended</div>';
      }, 500); // 0.5s delay
    }formatDisplayValue(value) {
      if (value < 10 && value >= 0) {
        return `0${value}`;
      }
      return value.toString();
    }

    parseNumber(text) {
      return parseInt(text.trim(), 10);
    }

    isValidNumber(text) {
      const num = this.parseNumber(text);
      return !isNaN(num) && num > 0;
    }

    destroy() {
      this.timers.forEach(({intervalId}, timerId) => {
        clearInterval(intervalId);
        this.timers.delete(timerId);
      });
    }

    reinitialize() {
      this.destroy();
      this.initializeTimers();
    }
  }

// Initialize timer when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    window.countdownTimer = new CountdownTimer();
  });

// For Shopify theme editor compatibility
  if (typeof Shopify !== 'undefined') {
    document.addEventListener('shopify:section:load', () => {
      if (window.countdownTimer) {
        window.countdownTimer.reinitialize();
      }
    });

    document.addEventListener('shopify:section:unload', () => {
      if (window.countdownTimer) {
        window.countdownTimer.destroy();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-info-new-layout"] && !Shopify.designMode) return;
  try {
    class CountdownTimer {
    constructor() {
      this.timers = new Map();
      this.init();
    }

    init() {
      this.initializeTimers();
    }

    initializeTimers() {
      const containers = document.querySelectorAll('.category-status-container');

      containers.forEach((container, index) => {
        const timer = container.querySelector('.timer-layout-minutes');

        if (timer) {
          this.startCountdown(container, `timer-${index}`, timer);
        }
      });
    }

    startCountdown(container, timerId, timer) {
      const timerPartOneSpan = timer?.querySelector('.timer-part-01 span');

      if (!this.isValidNumber(timerPartOneSpan.textContent)) {
        return;
      }

      let currentValue = this.parseNumber(timerPartOneSpan.textContent);

      const intervalId = setInterval(() => {
        currentValue--;

        timerPartOneSpan.textContent = this.formatDisplayValue(currentValue);

        if (currentValue <= 0) {
          this.handleTimerEnd(intervalId, timerId, container, timer);
        }
      }, 58000);

      this.timers.set(timerId, { intervalId, container, timerPartOneSpan });
    }

    handleTimerEnd(intervalId, timerId, container, timer) {
      const timerPartTwo = timer?.querySelector('.timer-part-02');
      const timerPartOneSpan = timer?.querySelector('.timer-part-01 span');

      clearInterval(intervalId);
      this.timers.delete(timerId);

      timerPartOneSpan.textContent = '00';
      timerPartOneSpan.classList.add('timer-ended');

      timerPartTwo.innerHTML = '<div class="counter-number"><span>00</span></div>';

      setTimeout(() => {
        container.innerHTML = '<div class="status-badge ended">Ended</div>';
      }, 500); // 0.5s delay
    }

    formatDisplayValue(value) {
      if (value < 10 && value >= 0) {
        return `0${value}`;
      }
      return value.toString();
    }

    parseNumber(text) {
      return parseInt(text.trim(), 10);
    }

    isValidNumber(text) {
      const num = this.parseNumber(text);
      return !isNaN(num) && num > 0;
    }

    destroy() {
      this.timers.forEach(({ intervalId }, timerId) => {
        clearInterval(intervalId);
        this.timers.delete(timerId);
      });
    }

    reinitialize() {
      this.destroy();
      this.initializeTimers();
    }
  }

  // Initialize timer when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    window.countdownTimer = new CountdownTimer();
  });

  // For Shopify theme editor compatibility
  if (typeof Shopify !== 'undefined') {
    document.addEventListener('shopify:section:load', () => {
      if (window.countdownTimer) {
        window.countdownTimer.reinitialize();
      }
    });

    document.addEventListener('shopify:section:unload', () => {
      if (window.countdownTimer) {
        window.countdownTimer.destroy();
      }
    });
  }

  // Info JS Start

  const gallery = document.getElementById('verticalGallery');
  const items = document.querySelectorAll('.product-gallery-vertical__item');
  const dots = document.querySelectorAll('.pg-dot');

  let blockScroll = false;

  function activateDot(index) {
    dots.forEach((d) => d.classList.remove('active'));
    if (dots[index]) dots[index].classList.add('active');
  }

  /* ===============================
     SCROLL → DOT SYNC (70% rule)
  =============================== */

  const observer = new IntersectionObserver(
    (entries) => {
      if (blockScroll) return;

      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.7) {
          const index = [...items].indexOf(entry.target);
          activateDot(index);
        }
      });
    },
    {
      root: gallery, // IMPORTANT: scroll container
      threshold: [0.7], // 70% visibility rule
    }
  );

  items.forEach((item) => observer.observe(item));

  /* ===============================
     DOT CLICK → SCROLL
  =============================== */

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      const target = document.getElementById(dot.dataset.target);
      if (!target) return;

      blockScroll = true;
      activateDot(i);

      gallery.scrollTo({
        top: target.offsetTop,
        behavior: 'smooth',
      });

      setTimeout(() => {
        blockScroll = false;
      }, 500);
    });
  });

  (function () {
    'use strict';

    const variantPickerElement = document.querySelector('variant-picker');
    const SIZE_SELECTION_ERROR_TEXT = 'Please select a size.';

    function hasSizeOptionOnPage() {
      const legends = document.querySelectorAll('.variant-picker__option legend');
      return Array.from(legends).some((legend) => (legend.textContent || '').toLowerCase().includes('size'));
    }

    function setSizeSelectionErrorState(isError) {
      const desktopSizeButtons = Array.from(document.querySelectorAll('.variant-picker__option')).filter((field) => {
        const legendText = field.querySelector('legend')?.textContent || '';
        return legendText.toLowerCase().includes('size');
      }).map((field) => field.querySelector('.select'));

      desktopSizeButtons.forEach((button) => {
        if (!button) return;
        button.classList.toggle('gs-size-error-state', isError);
      });

      const mobileSizeDisplay = document.querySelector('#variant-picker-for-mobile .ps-custom-select-display') || document.querySelector('.ps-custom-select-display');
      if (mobileSizeDisplay) {
        mobileSizeDisplay.classList.toggle('gs-size-error-state', isError);
      }

      const atcButtons = document.querySelectorAll('.buy-buttons .button, .nl-mobile-custom-buy-btn');
      atcButtons.forEach((button) => {
        if (!button) return;

        if (isError) {
          if (!button.hasAttribute('data-gs-size-error-prev-disabled')) {
            button.setAttribute('data-gs-size-error-prev-disabled', button.disabled ? 'true' : 'false');
          }

          button.disabled = true;
          button.classList.add('gs-size-error-disabled');
        } else {
          const prevDisabled = button.getAttribute('data-gs-size-error-prev-disabled');
          if (prevDisabled !== null) {
            button.disabled = prevDisabled === 'true';
            button.removeAttribute('data-gs-size-error-prev-disabled');
          }

          button.classList.remove('gs-size-error-disabled');
        }
      });
    }

    function showSizeSelectionError(message = SIZE_SELECTION_ERROR_TEXT) {
      if ((message || '').trim().toLowerCase() === SIZE_SELECTION_ERROR_TEXT.toLowerCase()) {
        setSizeSelectionErrorState(true);
        return;
      }

      const isMobileView = window.matchMedia('(max-width: 999px)').matches;
      let target = null;

      if (isMobileView) {
        target =
          document.querySelector('#variant-picker-for-mobile .ps-custom-select-wrapper') ||
          document.querySelector('#variant-picker-for-mobile') ||
          document.querySelector('.ps-custom-select-wrapper') ||
          document.querySelector('#variant-picker-for-mobile');
      } else {
        const desktopSizeFieldset = Array.from(document.querySelectorAll('.variant-picker__option')).find((field) => {
          const legendText = field.querySelector('legend')?.textContent || '';
          return legendText.toLowerCase().includes('size');
        });

        target = desktopSizeFieldset || document.querySelector('.variant-picker');
      }

      if (!target || !target.parentElement) return;

      let existingBanner = target.parentElement.querySelector('.banner.banner--error.gs-size-select-error');
      if (existingBanner) existingBanner.remove();

      const bannerElement = document.createRange().createContextualFragment(`
        <div class="banner banner--error gs-size-select-error" role="alert">
          ${message}
        </div>
      `).firstElementChild;

      target.before(bannerElement);

      const removeDuplicateBuyButtonsErrors = () => {
        document.querySelectorAll('buy-buttons .banner.banner--error').forEach((el) => el.remove());
      };

      removeDuplicateBuyButtonsErrors();
      setTimeout(removeDuplicateBuyButtonsErrors, 0);
      setTimeout(() => bannerElement.remove(), 2500);
    }

    function isSizeSelectionPending() {
      return hasSizeOptionOnPage() && document.querySelector('.buy-buttons-inactive') !== null;
    }

    function updateBuyBtnsStatus( status ){

      if(variantPickerElement){
        const buyBtns = document.querySelectorAll('.buy-buttons, .nl-mobile-custom-buy-btn');
        if(status == 'active'){
          buyBtns.forEach((btn) => btn.classList.remove('buy-buttons-inactive'));
        }

        if(status == 'inactive'){
          buyBtns.forEach((btn) => btn.classList.add('buy-buttons-inactive'));
        }
      }

    }  

    const atcAnimationTimers = new Map();

    function getAtcButtonsForAnimation(targetButton = null) {
      const buttonPool = targetButton
        ? [targetButton]
        : Array.from(document.querySelectorAll('.buy-buttons .button, .nl-mobile-custom-buy-btn'));

      return buttonPool.filter((button) => {
        return button && !button.classList.contains('gs-size-error-disabled');
      });
    }

    function clearAtcAnimationTimers(button) {
      const timers = atcAnimationTimers.get(button) || [];
      timers.forEach((timerId) => clearTimeout(timerId));
      atcAnimationTimers.delete(button);
    }

    function resetAtcButtonAnimation(button) {
      const originalLabel = button.dataset.gsAtcOriginalLabel || 'ADD TO CART';
      clearAtcAnimationTimers(button);
      button.classList.remove('gs-atc-anim', 'gs-atc-stage-1', 'gs-atc-stage-2', 'gs-atc-stage-3');
      button.innerHTML = originalLabel;
      delete button.dataset.gsAtcAnimating;
      delete button.dataset.gsAtcOriginalLabel;
      delete button.dataset.gsAtcAdded;
    }

    function startAtcClickAnimation(targetButton = null) {
      getAtcButtonsForAnimation(targetButton).forEach((button) => {
        if (button.dataset.gsAtcAdded === '1') {
          resetAtcButtonAnimation(button);
        }

        if (button.dataset.gsAtcAnimating === '1') return;

        const originalLabel = (button.textContent || '').trim() || 'ADD TO CART';
        button.dataset.gsAtcOriginalLabel = originalLabel;
        button.dataset.gsAtcAnimating = '1';
        button.innerHTML = `
          <span class="gs-atc-label">${originalLabel}</span>
          <span class="gs-atc-dots"><i></i><i></i><i></i></span>
          <span class="gs-atc-added">Added</span>
          <span class="gs-atc-wipe"></span>
        `;

        button.classList.add('gs-atc-anim');
        requestAnimationFrame(() => {
          button.classList.add('gs-atc-stage-1');
        });

        const fallbackReset = setTimeout(() => {
          resetAtcButtonAnimation(button);
        }, 2400);
        atcAnimationTimers.set(button, [fallbackReset]);
      });
    }

    function completeAtcSuccessAnimation() {
      getAtcButtonsForAnimation().forEach((button) => {
        if (button.dataset.gsAtcAnimating !== '1') return;

        clearAtcAnimationTimers(button);
        button.classList.add('gs-atc-stage-2');

        const toStage3 = setTimeout(() => {
          button.classList.remove('gs-atc-stage-1');
          button.classList.add('gs-atc-stage-3');
          button.dataset.gsAtcAdded = '1';
          delete button.dataset.gsAtcAnimating;
        }, 730);

        atcAnimationTimers.set(button, [toStage3]);
      });
    }

    function cancelAtcClickAnimation(targetButton = null) {
      getAtcButtonsForAnimation(targetButton).forEach((button) => {
        if (button.dataset.gsAtcAnimating !== '1') return;
        resetAtcButtonAnimation(button);
      });
    }

    function clearAtcAddedState(excludedButton = null) {
      document.querySelectorAll('.buy-buttons .button, .nl-mobile-custom-buy-btn').forEach((button) => {
        if (button === excludedButton) return;
        if (button.dataset.gsAtcAdded === '1') {
          resetAtcButtonAnimation(button);
        }
      });
    }

    /* ==============================
     INIT VARIANT SELECTORS
  ============================== */
    function initVariantSelectors() {
      const selectButtons = document.querySelectorAll('.select');

      selectButtons.forEach((button) => {
        // Prevent double initialization (VERY IMPORTANT)
        if (button.dataset.initialized === 'true') return;
        button.dataset.initialized = 'true';

        const popoverId = button.getAttribute('aria-controls');
        const selectedValueSpan = button.querySelector('span[id*="-selected-value"]');
        const visibleLabel = button.querySelector('.select-visible-label');

        if (!popoverId || !selectedValueSpan) return;

        const popover = document.getElementById(popoverId);
        if (!popover) return;

        const inputs = popover.querySelectorAll('input[type="radio"]');


        /* ==============================
         UPDATE SELECTION STATE
      ============================== */
        function updateSelection() {
          inputs.forEach((input) => {
            input.classList.remove('s-active');
            input.closest('.popover__value-option')?.classList.remove('s-active');
          });

          const checkedInput = [...inputs].find((input) => input.checked);

          if (checkedInput) {
            // Add selected state
            button.classList.add('s-selected');
            visibleLabel?.classList.add('s-selected');

            updateBuyBtnsStatus('active');
            setSizeSelectionErrorState(false);

            checkedInput.classList.add('s-active');
            checkedInput.closest('.popover__value-option')?.classList.add('s-active');

            const selectedText = checkedInput.nextElementSibling.textContent.trim();
            selectedValueSpan.textContent = `SELECTED SIZE: ${selectedText}`;
          } else {
            // Reset state
            button.classList.remove('s-selected');
            visibleLabel?.classList.remove('s-selected');
            selectedValueSpan.textContent = 'Select a Size';

            updateBuyBtnsStatus('inactive');

          }
        }

        /* ==============================
         EVENT LISTENERS
      ============================== */
        inputs.forEach((input) => {
          input.addEventListener('change', updateSelection);
        });

        button.addEventListener('click', () => {
          if (button.getAttribute('aria-expanded') === 'false') {
            selectedValueSpan.textContent = 'Select a Size';
            button.classList.remove('s-selected');
            // Uncheck all radios to reset actual selection
            inputs.forEach((input) => (input.checked = false));
            updateSelection();
          }
        });

        // Initial sync (important for preselected variants)
        updateSelection();
      });
    }

    /* ==============================
     ADDITIONAL FIX FOR MOBILE VARIANT SELECTOR
  ============================== */
    function initMobileVariantSelectors() {
      const selectElement = document.querySelector('.nl-pro-size');
      const buyButton = document.querySelector('.nl-mobile-custom-buy-btn');
      const addToCartButton = document.querySelector('.nl-mobile-custom-buy-btn');
      const productFormElement = document.querySelector('product-form');
      const productForm = productFormElement?.querySelector('form');

      function normalizeValue(value) {
        return (value || '').toString().trim().toLowerCase();
      }

      function syncDesktopSizeInput(selectedValue) {
        if (!selectedValue) return;

        const normalizedSelectedValue = normalizeValue(selectedValue);
        const sizeInputs = document.querySelectorAll('input[type="radio"][data-option-position="1"]');

        sizeInputs.forEach((input) => {
          const optionRow = input.closest('label, .popover__value-option');
          const optionText = optionRow?.querySelector('span')?.textContent;

          if (normalizeValue(optionText) === normalizedSelectedValue && input.checked === false) {
            input.click();
          }
        });
      }

      if (selectElement) {
        selectElement.addEventListener('change', (e) => {
          const selectedValue = e.target.value;
          const selectedOption = e.target.querySelector(`option[value="${selectedValue}"]`);

          // Update the size display based on the selected option
          const sizeDisplay = document.querySelector('.ps-display-selected');
          if (sizeDisplay) {
            sizeDisplay.textContent = selectedOption ? selectedOption.textContent : 'Select a Size';
          }

          syncDesktopSizeInput(selectedValue);

          // Enable the buy button after selection
          if (buyButton) {
            updateBuyBtnsStatus(selectedValue ? 'active' : 'inactive');
          }

          if (selectedValue) {
            setSizeSelectionErrorState(false);
          }
        });
      }

      if (addToCartButton) {
        addToCartButton.addEventListener('click', (e) => {
          e.preventDefault();

          if (isSizeSelectionPending()) {
            showSizeSelectionError();
            return;
          }

          if (selectElement) {
            syncDesktopSizeInput(selectElement.value);
          }

          const variantIdInput = productForm?.querySelector('input[name="id"]');
          if (!productForm || !variantIdInput || !variantIdInput.value) {
            if (hasSizeOptionOnPage()) showSizeSelectionError();
            return;
          }

          if (typeof productForm.requestSubmit === 'function') {
            productForm.requestSubmit();
          } else {
            productForm.submit();
          }
        });
      }

      // Desktop and mobile safety net: block submit if size exists but no variant is selected.
      if (productForm) {
        productForm.addEventListener(
          'submit',
          (event) => {
            const variantIdInput = productForm.querySelector('input[name="id"]');
            const hasVariantSelected = variantIdInput && variantIdInput.value;

            if (hasSizeOptionOnPage() && !hasVariantSelected) {
              event.preventDefault();
              event.stopPropagation();
              showSizeSelectionError();
              cancelAtcClickAnimation();
            }
          },
          true
        );
      }

      productForm?.addEventListener('variant:add', () => {
        completeAtcSuccessAnimation();
      });

      // Route Shopify/server cart errors to the same banner placement above size selector.
      productFormElement?.addEventListener('cart:error', function (event) {
        const errorMessage = event?.detail?.error;
        if (!errorMessage) return;
        cancelAtcClickAnimation();
        showSizeSelectionError(errorMessage);
      });

      document.addEventListener(
        'click',
        (event) => {
          const clickedAddToCart = event.target.closest('.buy-buttons .button, .nl-mobile-custom-buy-btn');
          if (!clickedAddToCart) {
            clearAtcAddedState();
            return;
          }

          const blockedButton = clickedAddToCart.closest('.buy-buttons-inactive');
          if (blockedButton && isSizeSelectionPending()) {
            event.preventDefault();
            event.stopPropagation();
            showSizeSelectionError();
            return;
          }

          clearAtcAddedState(clickedAddToCart);
          startAtcClickAnimation(clickedAddToCart);
        },
        true
      );

    }

    function forceClearInitialVariant() {
      // 1. Clear hidden variant input (THIS IS CRITICAL)
      document.querySelectorAll('form.shopify-product-form input[name="id"]').forEach((input) => {
        input.value = '';
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      // 2. Clear desktop radios
      document.querySelectorAll('input[type="radio"][data-option-position]').forEach((input) => {
        input.checked = false;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      // 3. Clear mobile select
      const mobileSelect = document.querySelector('.nl-pro-size');
      if (mobileSelect) {
        mobileSelect.selectedIndex = 0;
        mobileSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // 4. Disable buy buttons
      updateBuyBtnsStatus('inactive');

    }

    /* ==============================
     DOM READY
  ============================== */
    document.addEventListener('DOMContentLoaded', () => {
      initVariantSelectors();
      initMobileVariantSelectors();

      // Initial UI reset for Desktop
      document.querySelectorAll('.select-visible-label').forEach((label) => {
        label.classList.remove('s-selected');
        label.textContent = 'Select a Size';
      });
      
      // Initial UI reset for mobile
      updateBuyBtnsStatus('inactive');


    });
  })();

  // SIZE GUIDE APPEND TO MOBILE BLANK DIV
  (function () {
    const DESKTOP_ID = 'size-guide-desktop';
    const MOBILE_ID = 'size-guide-mobile';
    const BREAKPOINT = 999;

    let originalParent = null;
    let originalNextSibling = null;

    function moveSizeGuide() {
      const isMobile = window.innerWidth <= BREAKPOINT;

      const sizeGuideEl = document.getElementById(DESKTOP_ID);
      const mobileContainer = document.getElementById(MOBILE_ID);

      if (!sizeGuideEl || !mobileContainer) return;

      // Store original position once
      if (!originalParent) {
        originalParent = sizeGuideEl.parentNode;
        originalNextSibling = sizeGuideEl.nextSibling;
      }

      if (isMobile) {
        // Move into mobile container
        if (!mobileContainer.contains(sizeGuideEl)) {
          mobileContainer.appendChild(sizeGuideEl);
        }
      } else {
        // Move back to exact original position
        if (originalParent && !originalParent.contains(sizeGuideEl)) {
          originalParent.insertBefore(sizeGuideEl, originalNextSibling);
        }
      }
    }
    // Initial run
    moveSizeGuide();
    // Resize listener
    window.addEventListener('resize', moveSizeGuide);
  })();

  document.addEventListener('DOMContentLoaded', () => {
    // COLOR SWATCHES
    const swatchContainers = document.querySelectorAll('.nl-color-swatches');
    swatchContainers.forEach((container, index) => {
      const swatches = container.querySelectorAll('.nl-color-swatch');
      const colorText = container.querySelector('.selected-color-text');
      const radios = container.querySelectorAll('input[type="radio"][name="color"]');
      if (swatches.length > 0) {
        swatches.forEach((s) => s.classList.remove('active-checked'));
        swatches[0].classList.add('active-checked');
        if (colorText) {
          colorText.textContent = swatches[0].dataset.colorName;
        }
      }
      swatches.forEach((swatch) => {
        swatch.addEventListener('click', () => {
          swatches.forEach((s) => s.classList.remove('active-checked'));
          swatch.classList.add('active-checked');

          // Update the text for this container
          if (colorText) {
            colorText.textContent = swatch.dataset.colorName;
          }
        });
      });
    });

    // CUSTOM SIZE DROPDOWN
    document.querySelectorAll('.ps-custom-select-wrapper').forEach((wrapper) => {
      const select = wrapper.querySelector('.nl-pro-size'); // single select per wrapper
      const display = wrapper.querySelector('.ps-custom-select-display');
      const placeholderText = display.querySelector('.ps-display-placeholder');
      const selectedText = display.querySelector('.ps-display-selected');
      const optionsContainer = wrapper.querySelector('.ps-custom-select-options');

      // Populate options
      select.querySelectorAll('option').forEach((option) => {
        if (option.value === '') return;

        const li = document.createElement('li');

        li.innerHTML = `
          <span class="variant-size">
            ${option.dataset.label}
          </span>

          ${
            option.dataset.inventoryMessage
              ? `<span class="variant-inventory">${
                  option.dataset.inventoryMessage
                    .replace('-', '')
                    .replace('!', '')
                    .trim()
                } !</span>`
              : ''
          }

          ${
            option.dataset.status
              ? `<span class="testing_variant">${option.dataset.status}</span>`
              : ''
          }
        `;

        if (option.selected) li.classList.add('active');

        optionsContainer.appendChild(li);

        li.addEventListener('click', () => {
          selectSize(option.value, li);
          toggleDropdown(false);
        });
      });

      // Dropdown toggle
      const toggleDropdown = (force) => {
        const willOpen = force !== undefined ? force : !display.classList.contains('open');
        optionsContainer.classList.toggle('open', willOpen);
        display.classList.toggle('open', willOpen);
      };

      // Display click
      display.addEventListener('click', () => {
        if (display.classList.contains('has-selection') && !display.classList.contains('open')) {
          selectSize('', null);
          toggleDropdown(true);
        } else {
          toggleDropdown();
        }
      });

      // Click outside
      document.addEventListener('click', (e) => {
        if (!wrapper.contains(e.target)) toggleDropdown(false);
      });

      // Select size function
      const selectSize = (value, clickedLi) => {
      optionsContainer.querySelectorAll('li').forEach((el) => el.classList.remove('active'));

      if (clickedLi) clickedLi.classList.add('active');

      select.value = value || '';
      select.dispatchEvent(new Event('change', { bubbles: true }));

      if (value) {
        const selectedOption = [...select.options].find(
          (option) => option.value === value
        );

        const sizeLabel = selectedOption?.dataset?.label || value;
        const inventoryMsg = (selectedOption?.dataset?.inventoryMessage || '')
        .replace('-', '')
        .replace('!', '')
        .trim();


        selectedText.innerHTML = `
          <span class="selected-size-label">
            Selected Size: ${sizeLabel}
          </span>
          ${
            inventoryMsg
              ? `<span class="selected-inventory-msg">${inventoryMsg} !</span>`
              : ''
          }
        `;

        display.classList.add('has-selection');
      } else {
        selectedText.innerHTML = '';
        display.classList.remove('has-selection');
      }
    };

      // Accessibility
      display.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          display.click();
        }
      });

      display.setAttribute('tabindex', '0');
      display.setAttribute('role', 'button');
      display.setAttribute('aria-haspopup', 'listbox');
    });

    //feature accordian
    const productDescriptionsWrapers = document.querySelectorAll('.product-description-section, .product-description-section .markdown ');
    productDescriptionsWrapers.forEach((wrapper) => {
      if (!wrapper) return;

      const nodes = Array.from(wrapper.childNodes);
      if (nodes.length === 0) return;

      let firstParagraph = null;
      let restNodes = [];

      // Find first <p>
      for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].nodeType === Node.ELEMENT_NODE && nodes[i].tagName.toLowerCase() === 'p') {
          firstParagraph = nodes[i];
          restNodes = nodes.slice(i + 1);
          break;
        }
      }

      if (!firstParagraph) return;

      // --------------------------
      // Short content truncate
      // --------------------------
      const MAX_CHARS = 120; // adjust for short preview
      const fullText = firstParagraph.innerText.trim();

      let firstPart = fullText;
      let restFirstP = '';

      if (fullText.length > MAX_CHARS) {
        let truncated = fullText.slice(0, MAX_CHARS);
        truncated = truncated.slice(0, truncated.lastIndexOf(' ')); // word-safe cut

        firstPart = truncated;
        restFirstP = fullText.slice(truncated.length).trim();
      }

      // Clear paragraph and add firstPart
      firstParagraph.innerHTML = firstPart;

      // --------------------------
      // More button (initial, short text ke saath)
      // --------------------------
      const moreBtn = document.createElement('span');
      moreBtn.classList.add('read-more-btn', 'more-btn');
      moreBtn.innerText = 'More';
      firstParagraph.appendChild(moreBtn); // append right after short text

      // --------------------------
      // Hidden content span (initially hidden)
      // --------------------------
      const hiddenSpan = document.createElement('span');
      hiddenSpan.classList.add('more-content', 'slide'); // initially hidden
      if (restFirstP.length > 0) {
        hiddenSpan.innerText = ' ' + restFirstP;
      }
      if (restNodes.length > 0) {
        restNodes.forEach((node) => hiddenSpan.appendChild(node));
      }
      firstParagraph.appendChild(hiddenSpan);

      // --------------------------
      // Less button (will be appended dynamically at end of hidden content)
      // --------------------------
      const lessBtn = document.createElement('span');
      lessBtn.classList.add('read-more-btn', 'less-btn');
      lessBtn.innerText = ' Less';

      // --------------------------
      // More button click
      // --------------------------
      moreBtn.addEventListener('click', function () {
        hiddenSpan.classList.add('show'); // show hidden content
        moreBtn.style.display = 'none'; // hide More button
        if (!firstParagraph.contains(lessBtn)) {
          firstParagraph.appendChild(lessBtn); // add Less button at end
        }
      });

      // --------------------------
      // Less button click
      // --------------------------
      lessBtn.addEventListener('click', function () {
        hiddenSpan.classList.remove('show'); // hide hidden content
        lessBtn.remove(); // remove Less button
        moreBtn.style.display = 'inline'; // show More button again
      });

      // --------------------------
      // Ensure description content is visible immediately.
      const loader = wrapper.querySelector('#desc-loader');
      const descElements = wrapper.querySelectorAll('p, ul');

      if (loader) loader.style.display = 'none';
      descElements.forEach((el) => {
        el.style.display = 'block';
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
